import { Box, Typography } from '@mui/material'
import React from 'react'
import { SectionTitle } from '../../../components'

const ContactStatement = () => {

    const CustomSpan = ({children}) => {
        return(
        <Typography
            component='span'
            sx={{
                fontWeight:'bold',
                fontSize:'inherit',
                cursor:'pointer',
            }}
        >{children}</Typography>
    )}
  return (
    <Box
        sx={{
            width:'70%',
            '@media screen and (max-width:762px)':{
                width:'100%'
            }
        }}
    >
        <Box // line beside title
            sx={{
            height:'0.2rem',
            width:'10rem',
            backgroundColor:'#000',
            alignContent:'center',
            alignItems:'center',
            marginRight:'2rem',
            }}
        />

        <Box
            sx={{
                padding:'2rem 0 2rem 5rem',
                '@media screen and (max-width:762px)':{
                    padding:'1rem'
                }
            }}
        >
            <Typography
                variant='h1'
                sx={{
                    fontFamily:'var(--title-font)',
                    fontSize:'2rem',
                    textTransform:'capitalize',
                    fontWeight:'500',
                    paddingY:'2rem',
                    '@media screen and (max-width:762px)':{
                        paddingY:'1rem'
                    }
                }}
            >
                let's build something extraordinary
            </Typography>

            <Typography
                variant='body'
                sx={{
                    fontFamily:'var(--text-font)',
                    fontSize:'1.2rem',
                    '@media screen and (max-width:762px)':{
                        fontSize:'1rem',
                    }
                }}
            >
                Whether you're planning a <CustomSpan>New Residential Build, 
                need an expert</CustomSpan> support for a
                <CustomSpan> Commercial or Industrial Build, </CustomSpan>
                or are looking for a <CustomSpan>reliable partner for Civil Construction&mdash;Pangu Enterprises </CustomSpan>
                is here to help. We're happy to <CustomSpan>answer your questions, discuss your vision, </CustomSpan>
                and provide <CustomSpan>Customized plan</CustomSpan> for your project.
            </Typography>
        </Box>

    </Box>
  )
}

export default ContactStatement